// extracted by mini-css-extract-plugin
export default {"mono":"ajFBS1NZudd_WSan7Kzy"};